import { Outlet } from 'react-router-dom';

import bg from '@/assets/images/auth-layout-bg.webp';
import bgPattern from '@/assets/images/BG Pattern.webp';
import logo from '@/assets/images/field-pro-logo.webp';

import styles from './auth-layout.module.scss';

export function AuthLayout() {
  return (
    <div className={styles.layout}>
      <aside className={styles.brand} style={{ backgroundImage: `url(${bg})` }}>
        <img src={logo} alt="FieldPro" className={styles.logo} />
      </aside>
      <section className={styles.panel}>
        <img src={bgPattern} alt="bg-pattern" className={styles.bgPattern} />
        <main className={styles.outlet}>
          <Outlet />
        </main>
        <footer className={styles.footer}>Terms of Service • Privacy Policy</footer>
      </section>
    </div>
  );
}
